<script>
import CoreComponent from "../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue";

export default {
  extends: CoreComponent,

  mounted() {
    console.log("test");
  },
};
</script>

<style lang="scss">
@import "./shortEventList.scss";
</style>
